// Module
var code = `<preview-button btn-size="{{ buttonController.btnSize }}" btn-type="{{ buttonController.btnType }}" btn-context="{{ buttonController.btnContext }}" ng-click="buttonController.open(\$event)"> </preview-button> `;
// Exports
module.exports = code;